/**
 * Handle region zoom
 */
export const handleRegionZoom = ({ google, map, markers, wrap }) => {
	const toggles = wrap.querySelectorAll('.resort-map__tab-button--toggle');
	if (toggles) {
		toggles.forEach((buttonEl) => {
			let timer = null;
			buttonEl.addEventListener('click', () => {
				clearTimeout(timer);
				timer = setTimeout(() => {
					let titles = [];
					buttonEl.parentElement
						.querySelectorAll('ul')
						?.forEach((ul) => {
							if (ul.dataset.within) {
								titles = [
									...titles,
									...ul.dataset.within.split(','),
								];
							}
						});
					if (titles.length) {
						bounds = new google.maps.LatLngBounds();
						markers.forEach((marker) => {
							if (titles.includes(marker.pin.title)) {
								bounds.extend(marker.pin.position);
							}
						});
						map.fitBounds(bounds, 50);
						const listener = google.maps.event.addListener(
							map,
							'idle',
							() => {
								if (map.getZoom() > 8) map.setZoom(8);
								google.maps.event.removeListener(listener);
							}
						);
					}
				}, 100);
			});
			toggles[0].click();
		});
	}
};
